import { type Configuration, LogLevel } from '@azure/msal-browser';

interface IMsalConfigurationOptions {
    authority: string;
    clientId: string;
    logToConsole: boolean;
}

// @ai-generated 2026-10-29T10:48:14+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** The MSAL browser configuration. MSAL's log messages reach the console only when `logToConsole` is set. */
export function createMsalConfiguration({
    authority,
    clientId,
    logToConsole,
}: IMsalConfigurationOptions): Configuration {
    return {
        auth: {
            clientId,
            authority,
            redirectUri: '/',
            postLogoutRedirectUri: '/logout',
        },
        cache: {
            cacheLocation: 'localStorage',
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii || !logToConsole) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.debug(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                },
            },
        },
    };
}
